import { IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';

export const selectPromoInfo = (state: IApplicationState): IPromo | null => {
  return state.promoInfo.promo;
};
